exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TrackVolumeControl.mod-trackNo-1 .SliderControl-bar {\n  background-color: #01f3af; }\n\n.TrackVolumeControl.mod-trackNo-2 .SliderControl-bar {\n  background-color: #00ede5; }\n\n.TrackVolumeControl.mod-trackNo-3 .SliderControl-bar {\n  background-color: #5286ff; }\n\n.TrackVolumeControl.mod-trackNo-4 .SliderControl-bar {\n  background-color: #b563e2; }\n", ""]);

// exports
